import { ChildrenProps } from '@gv/triage-components';
import { Icon, LinkProps } from '@gv/triage-components';
import { useMemo, useState, createContext } from 'react';

import { AppRoutes } from 'config';

interface SidebarContextProps {
  isOpened: boolean;
  links: LinkProps[];
  setOpened: (isOpened: boolean) => void;
}

const getInitialState = (): SidebarContextProps => ({
  links: [],
  isOpened: false,
  setOpened: () => {},
});

export const SidebarContext =
  createContext<SidebarContextProps>(getInitialState());

export const SidebarContextProvider = ({
  children,
}: ChildrenProps): JSX.Element => {
  const [isOpened, setOpened] = useState(getInitialState().isOpened);

  const links = useMemo(() => {
    const options: LinkProps[] = [];

    // TODO: use permissions or redo to just return
    options.push({
      title: 'Mock',
      icon: <Icon.List />,
      path: AppRoutes.Mock.Home,
    });

    return options;
  }, []);

  const value = {
    links,
    isOpened,
    setOpened,
  };

  return (
    <SidebarContext.Provider value={value}>{children}</SidebarContext.Provider>
  );
};
